import React from 'react'
import Header from '../Components/Header/Header'
import Footer from '../Components/Footer/Footer'
import Enrollaction from '../Components/Enrollaction/Enrollaction'
import Partnersec from '../Components/Partnersec/Partnersec'
import Courseprof from '../Components/Courseprof/Courseprof'

const Courseforprof = () => {
  return (
    <div>
        <Header/>
        <main>
            <section className='section-banner pg-banner mb-5 p-lg-5 pt-4'>
                    <div class="container text-center">
                          <div class="row justify-content-around ">
                              <div class="col-md">
                              <div class="pg-title-sec p-lg-5 p-4 bg-3 dark-bg">
                                    <h1 className='pg-title pb-3'>VLSI Courses for Working Professionals</h1>
                                    <p className='pg-title-desc mb-lg-5'>Takshila VLSI institute is among the top 10 VLSI training institutes in India. At Takshila, we understand the changing demands in the field of VLSI.
                                    </p>
                                </div>
                              </div>
                          </div>
                    </div>
            </section> 
            <section className='course-list bg-14'>
              <div class="container text-center">
                  <div class="row align-items-start">
                    <div class="col-lg">
                    <Courseprof/>
                    </div>
                  </div>
                </div>
            </section>
        </main> 
        <Enrollaction/>
        <Partnersec/> 
        <Footer/> 
    </div>
  )
}

export default Courseforprof